import * as Yup from "yup"
import { normalizeLocationName } from "./partnerSignupUtils"

const requiredMessage = "Ce champ est obligatoire."

export const storeValidationSchema = Yup.object({
  name: Yup.string().trim().required(requiredMessage),
  address: Yup.string().trim().required(requiredMessage),
  zipCode: Yup.number()
    .typeError("Le code postal doit être numérique.")
    .integer("Le code postal doit être numérique.")
    .positive("Le code postal doit être valide.")
    .required(requiredMessage),
  city: Yup.string()
    .trim()
    .required(requiredMessage)
    .test(
      "casablanca-only",
      "Pour le lancement, Wevalo est uniquement disponible à Casablanca.",
      value => normalizeLocationName(value) === "casablanca"
    ),
  country: Yup.string().trim().required(requiredMessage),
  website: Yup.string().trim().url("Saisissez une URL valide, par exemple https://exemple.com.").nullable(),
  activityId: Yup.string().required("Sélectionnez un secteur d’activité."),
  location: Yup.object({
    latitude: Yup.number()
      .typeError("La latitude doit être un nombre.")
      .min(-90, "La latitude doit être comprise entre -90 et 90.")
      .max(90, "La latitude doit être comprise entre -90 et 90.")
      .required("La latitude est obligatoire."),
    longitude: Yup.number()
      .typeError("La longitude doit être un nombre.")
      .min(-180, "La longitude doit être comprise entre -180 et 180.")
      .max(180, "La longitude doit être comprise entre -180 et 180.")
      .required("La longitude est obligatoire."),
  }),
})

export const adminValidationSchema = Yup.object({
  email: Yup.string().trim().email("Saisissez une adresse email valide.").required(requiredMessage),
  fullName: Yup.string().trim().required(requiredMessage),
  password: Yup.string().min(8, "Le mot de passe doit contenir au moins 8 caractères.").required(requiredMessage),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password")], "Les mots de passe ne correspondent pas.")
    .required(requiredMessage),
})
